module.exports = __webpack_public_path__ + "static/elastic-69917c9cbef45983439d1568e7b97a93.png";